import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, OnChanges,Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CandidateDisabilityService } from '../../service/candidate-disability/candidate-disability.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteCandidateDisabilityComponent),
  multi: true,
};

@Component({
    selector: 'app-autocomplete-candidate-disability',
    templateUrl: './autocomplete-candidate-disability.component.html',
    styleUrls: ['./autocomplete-candidate-disability.component.scss'],
    providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
  })
  export class AutocompleteCandidateDisabilityComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() candidateDisabilityId: number;
    @Input() candidateDisabilityIdCurrent: number;
    @Input() candidateId: any;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @ViewChild('input') textarea;
  
    public candidateDisabilitiesOptions: any[];
  
    public onChange: (value: any) => void = () => {};
    public onTouched: (value: any) => void = () => {};
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: { key: string; value: string }[];
  
    public sel: any;
  
    constructor(
      private renderer: Renderer2,
      public candidateDisabilityService: CandidateDisabilityService
    ) {
      this.page = 1;
      this.per_page = 10;
    }
  
    public ngOnInit() {}
  
    ngOnChanges() {
      this.query = undefined;
      this.filters = [];
      this.filters.push({ key: 'activated-lk', value: '1' });
      if (this.candidateDisabilityId) {
        this.filters.push({ key: 'id-lk', value: String(this.candidateDisabilityId) });
        this.getCandidateDisabilities(this.query);
      }
    }
  
    writeValue(value: any) {
      const div = this.textarea.nativeElement;
    }
  
    registerOnChange(fn: any) {
      this.onChange = fn;
    }
  
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
  
    setDisabledState(isDisabled: boolean) {
      const div = this.textarea.nativeElement;
      const action = isDisabled ? 'addClass' : 'removeClass';
      this.renderer[action](div, 'disabled');
    }
  
    public change($event) {
      this.onMyChange.emit(this.sel);
      if (this.onChange) this.onChange(this.sel);
      if (this.onTouched) this.onTouched(this.sel);
    }
  
    public loadCandidateDisabilitiesLazy(event) {
      var str = event.query;
      var res = str.replace(/\s/g, '%');
      this.filters = [];
      if (this.candidateDisabilityIdCurrent) {
        this.filters.push({ key: 'id-current', value: String(this.candidateDisabilityIdCurrent) });
      }
      if(this.candidateId){
        if(this.candidateId != "")
          {
            var value = 0;
            this.candidateId.id ? value = this.candidateId.id : value = this.candidateId;  
            this.filters.push({ key: 'candidate_id', value: String(value) });
          }
          
      }
      this.getCandidateDisabilities(res);
    }
  
    getCandidateDisabilities(query?: string) {
      this.candidateDisabilityService
        .getCandidateDisabilityLow(this.page, this.per_page, this.sort, query, this.filters)
        .toPromise()
        .then(
          (response) => {
            this.candidateDisabilitiesOptions = response.json().data;
            this.candidateDisabilitiesOptions.forEach((candidateDisabilityOption) => {
              candidateDisabilityOption.label = candidateDisabilityOption.id
            });
            if (this.candidateDisabilityId) {
              this.candidateDisabilityId = undefined;
              this.sel = this.candidateDisabilitiesOptions[0];
              this.filters = [];
              // this.filters.push({ key: 'activated-lk', value: '1' });
            }
          },
          (error) => {
            this.candidateDisabilitiesOptions = [];
            this.candidateDisabilitiesOptions.push({ id: '', name: 'Error' });
          }
        );
    }
}
  


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/custom-autocomplete/components/autocomplete-candidate-disability/autocomplete-candidate-disability.component.ts